<template>
  <div class="container">
    <navBar/>
    <div class="mt-5 flex w-full">
      <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/4 mx-auto text-center">
        <img src="@/assets/images/document/sign-success.svg" alt="Success" width="465" class="mx-auto mb-4 max-w-full">
        <h1 class="sm:mx-0 mt-5 mb-10 text-5xl d-theme-heading-color">Documento firmado</h1>
        <h4 class="sm:mx-0 mx-2 sm:mb-5 font-w-400">
          Este documento ya fue firmado anteriormente.
        </h4>

        <div class="buttons">
          <vs-button size="large" to="/" class="float-left mr-10 mt-5">Iniciar sesión</vs-button>
          <vs-button type="border" size="large" to="register" class="float-rightf mt-5">Registrate gratis</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";

export default {
  components: {
    navBar
  }
}
</script>

<style scoped lang="scss">
 @media (max-width: 768px) {
   .buttons{
     button{
       width: 100%!important;
       margin-bottom: 10px;
       margin-right: 0px;
     }
   }
 }
</style>
